import { useAuth } from 'context/AuthContext';
import { useMotoboys } from 'context/MotoboysContext';
import CreateMotoboy from 'pages/Motoboys/Create';
import React, { useCallback, useState, useEffect } from 'react';

import toast from 'react-hot-toast';
import api2 from 'services/api2';
import {
  Button,
  Checkbox,
  IconClose,
  IconIfood,
  IconMotorcycle,
  IconPlus,
  Modal,
  TabGroup,
} from 'takeat-design-system-ui-kit';
import { addMessageWhatsapp } from 'utils/handleNotifyWhatsapp';
import { ModalContainer, ModalContainerHeader } from './styles';
import { DefaultSelect } from 'ui-kit-takeat';
import IfoodOnDemand from 'components/Delivery/IfoodOnDemand';
import { Form } from '@unform/web';
import { add } from 'date-fns';
import { handleWhatsappIndicator } from 'utils/handleWhatsappIndicator';

export function ModalMotoboyOrders({
  items = [],
  openModalMotoboy,
  clearSelection,
  onClose,
}) {
  const { user } = useAuth();
  const wppOn = localStorage.getItem('@gddashboard:wppConnected');

  const [modalMotoboyOpen, setModalMotoboyOpen] = useState(false);
  function toggleModalMotoboy() {
    setModalMotoboyOpen(!modalMotoboyOpen);
    onClose();
  }

  const { motoboys } = useMotoboys();
  const initialData = {
    motoboy: {
      value: motoboys[0]?.id,
      label: motoboys[0]?.name,
    },
  };

  useEffect(() => {
    setModalMotoboyOpen(openModalMotoboy);
  }, [openModalMotoboy]);

  const [motoboyTab, setMotoboyTab] = useState(0);
  const [creatingMotoboy, setCreatingMotoboy] = useState(false);
  const [motoboySelected, setMotoboySelected] = useState(() => {
    return user.use_foody_delivery
      ? { label: 'Motoboy Padrão Foody', value: null }
      : null;
  });

  const [sendMsgMotoboy, setSendMsgMotoboy] = useState(
    JSON.parse(localStorage.getItem('@gddashboard:sendMsgMotoboy')) || false
  );

  const toggleMsgMotoboy = () => {
    setSendMsgMotoboy(!sendMsgMotoboy);
    localStorage.setItem('@gddashboard:sendMsgMotoboy', !sendMsgMotoboy);
  };

  const [orders, setOrders] = useState({});
  const getOrders = useCallback(async () => {
    try {
      const responses = await Promise.all(
        items.map((it) =>
          api2
            .get(`/restaurants/basket-orders/${it?.basket?.id}`)
            .then((res) => ({ id: it?.basket?.id, data: res.data }))
        )
      );

      const map = {};
      responses.forEach((data) => {
        map[data.id] = data.data;
      });

      setOrders(map);
    } catch (error) {
      console.log(error);
      setOrders({});
    }
  }, [items]);

  useEffect(() => {
    if (openModalMotoboy) getOrders();
  }, [openModalMotoboy, items, getOrders]);

  const getOrdersAndNotify = useCallback(async () => {
    try {
      await Promise.all(
        items.map(async (item) => {
          const response = await api2.get(
            `/restaurants/basket-orders/${item?.basket.id}`
          );
          const orders = response.data;
          if (wppOn === 'true') {
            addMessageWhatsapp({
              item,
              orders,
              user,
              status: 'motoboy',
            });
          }
        })
      );
    } catch (error) {
      console.log(error);
    }
  }, [items]);

  const [sendingMotoboy, setSendingMotoboy] = useState(false);

  const handleItemReady = async (noMotoboy = false) => {
    try {
      const responses = await Promise.all(
        items.map(async (item) => {
          const response = await api2.put(
            `restaurants/orders/${item.basket.id}`,
            {
              order_status:
                item.with_withdrawal === true ? 'delivered' : 'ongoing',
              ifood_id: item.basket.ifood_id,
              with_withdrawal: item.basket.with_withdrawal,
            }
          );

          if (noMotoboy && !item.with_withdrawal && wppOn === 'true') {
            addMessageWhatsapp({
              item,
              orders: [],
              user,
              status: 'ready',
            });
          }

          return response;
        })
      );

      // Handle WhatsApp indicator for each response
      responses.forEach((response) => {
        handleWhatsappIndicator(response.data?.whatsappIndicator);
      });

      clearSelection();
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddMotoboy = async (data) => {
    setSendingMotoboy(true);
    try {
      await Promise.all(
        items.map(async (item) => {
          if (item.with_withdrawal === true) {
            return (item.motoboy = null);
          }

          const response = await api2.post('/restaurants/motoboys/relate', {
            motoboy_id: motoboySelected.value,
            session_id: item?.session_id,
            is_foody: motoboySelected.value === null,
          });

          item.motoboy = response.data;

          if (!item?.basket.ifood_id && wppOn === 'true') {
            addMessageWhatsapp({
              item,
              orders: [],
              user,
              status: 'ready',
            });
          }

          if (sendMsgMotoboy && motoboySelected.phone) {
            getOrdersAndNotify();
          }

          setSendingMotoboy(false);
        })
      );

      toast.success(
        items.length > 1
          ? 'Motoboy adicionado às entregas'
          : 'Motoboy adicionado à entrega'
      );
      await handleItemReady();
      toggleModalMotoboy();
      clearSelection();
    } catch (err) {
      setSendingMotoboy(false);
      console.log('handleAddMotoboy Error: ', err);
      toast.error('Não foi possível adicionar motoboy à essa entrega');
    }
  };

  if (!items.length < 0) return null;

  const itemMap = items.map((item) => item);
  const haveIfoodId = itemMap.some((item) => item?.basket?.ifood_id !== null);

  console.log('haveIfoodId', haveIfoodId);

  return (
    <Modal
      open={modalMotoboyOpen}
      toggle={toggleModalMotoboy}
      style={{
        width: '500px',
        height: 'fit-content',
        padding: 16,
        minWidth: 'unset',
      }}
    >
      {/* Aqui que fica a disponibilidade de selecionar o Entrega Fácil */}
      {itemMap.length === 1 &&
        user.has_ifood &&
        user?.delivery_info?.use_ifood_on_demand &&
        !itemMap[0]?.basket?.ifood_id &&
        itemMap[0]?.buyer?.delivery_address?.latitude &&
        itemMap[0]?.buyer?.delivery_address?.longitude && (
          <div>
            <TabGroup
              variant="transparent"
              tabs={[
                {
                  text: 'Motoboy próprio',
                  icon: <IconMotorcycle style={{ fill: '#c8131b' }} />,
                },
                {
                  text: 'Entrega Fácil iFood',
                  icon: <IconIfood style={{ fill: '#c8131b' }} />,
                },
              ]}
              onTabChange={(e) => setMotoboyTab(e)}
              value={motoboyTab}
            />
          </div>
        )}

      {motoboyTab === 0 && (
        <div>
          {creatingMotoboy ? (
            <CreateMotoboy
              toggleModalRegisterMotoboy={() => setCreatingMotoboy(false)}
              motoboyCreated={(data) => {
                setMotoboySelected(data);
                setCreatingMotoboy(false);
              }}
            />
          ) : (
            <Form onSubmit={handleAddMotoboy} initialData={initialData}>
              <ModalContainer style={{ padding: 0 }}>
                <ModalContainerHeader>
                  <h3>Adicionar motoboy a essa entrega?</h3>
                  <IconClose
                    style={{ fontSize: 20, fill: '#c8131b' }}
                    onClick={() => {
                      toggleModalMotoboy();
                    }}
                  />
                </ModalContainerHeader>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                  }}
                >
                  <DefaultSelect
                    name="motoboy"
                    width="-webkit-fill-available"
                    options={motoboys.map((m) => {
                      return { value: m.id, label: m.name, phone: m.phone };
                    })}
                    value={motoboySelected}
                    onChange={(e) => setMotoboySelected(e)}
                  />

                  <Button
                    icon={<IconPlus />}
                    color="green"
                    onClick={() => setCreatingMotoboy(true)}
                  />
                </div>

                {user.use_wpp &&
                  motoboySelected !== null &&
                  motoboySelected?.value && (
                    <div>
                      <Checkbox
                        checked={sendMsgMotoboy && motoboySelected.phone}
                        label="Enviar detalhes do pedido para motoboy"
                        onClick={() => toggleMsgMotoboy()}
                        disabled={!motoboySelected.phone}
                      />

                      {!motoboySelected.phone && (
                        <span style={{ color: 'red' }}>
                          Este motoboy não possui telefone cadastrado
                        </span>
                      )}
                    </div>
                  )}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      toggleModalMotoboy();

                      if (!haveIfoodId) {
                        handleItemReady(true);
                      }
                    }}
                    title="Não adicionar motoboy"
                    disabled={sendingMotoboy}
                    isLoading={sendingMotoboy}
                  >
                    Não adicionar motoboy
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {}}
                    disabled={sendingMotoboy}
                    isLoading={sendingMotoboy}
                    color="green"
                  >
                    Adicionar
                  </Button>
                </div>
              </ModalContainer>
            </Form>
          )}
        </div>
      )}

      {motoboyTab === 1 && (
        <IfoodOnDemand
          item={items[0]}
          user={user}
          handleItemReady={handleItemReady}
          toggleModal={toggleModalMotoboy}
          orders={orders}
        />
      )}
    </Modal>
  );
}
